<template>
  <div class="flex flex-wrap gap-2">
    <TagBadge_V2
      v-for="(badge, index) in params.value"
      :key="index"
      :text="params.badgeTextVarName ? badge?.[params.badgeTextVarName] : badge?.name"
      :color="badge?.color"
    />
  </div>
</template>

<script>
import TagBadge_V2 from '@/components/widgetcomponents/TagBadge_V2.vue';

export default {
  components: {TagBadge_V2},
}
</script>
